import { faEye } from '@fortawesome/free-solid-svg-icons';

import { Cta } from 'apps/dashboard/shared/scripts/components';

interface Props {
  cardId: string;
}

const ViewCard = ({ cardId }: Props) => {
  return (
    <Cta faIcon={faEye} to={`/${cardId}?rd=1`} link mobile>
      View
    </Cta>
  );
};

ViewCard.displayName = 'ViewCard';

export default ViewCard;
